function getFechaSantiago(fecha = new Date()) {
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Santiago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(fecha);
}

function getHoraSantiago(fecha = new Date()) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Santiago',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
    const parts = formatter.formatToParts(fecha);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${map.hour}:${map.minute}:${map.second}`;
}

function getFechaCompletaSantiago(fecha = new Date()) {
    return new Date(`${getFechaSantiago(fecha)}T${getHoraSantiago(fecha)}`);
}

function esFeriado(fechaISO) {
    const feriados = ['2026-06-29','2026-05-21','2025-06-29','2026-07-16'];
    return feriados.includes(fechaISO);
}

function esDomingoHabilitado(fechaISO) {
    const domingosHabilitados = ['2025-05-04'];
    return domingosHabilitados.includes(fechaISO);
}

function obtenerProximoDiaHabil(fechaISO) {
    let fecha = new Date(`${fechaISO}T00:00:00`);
    while (true) {
        fecha.setDate(fecha.getDate() + 1);
        const fechaStr = getFechaSantiago(fecha);
        const dia = fecha.getDay();
        if (!esFeriado(fechaStr) && (dia !== 0 || esDomingoHabilitado(fechaStr))) {
            return fechaStr;
        }
    }
}

function mensajeProximoHabil(hoyISO, proximoISO) {
    const hoy = new Date(`${hoyISO}T00:00:00`);
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    const mananaISO = getFechaSantiago(manana);

    if (proximoISO === mananaISO) return 'Llega <span class="remaining-time">MAÑANA</span>';

    const diaSemana = ["DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO"];
    const dia = new Date(`${proximoISO}T00:00:00`).getDay();
    return `Llega el <span class="remaining-time">${diaSemana[dia]}</span>`;
}

function formatCountdown(ms) {
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    const pad = n => n.toString().padStart(2, '0');
    return `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
}

function updateCountdown(cutOffTime, element) {
    const tick = () => {
        const now = getFechaCompletaSantiago();
        let diff = cutOffTime - now;
        diff = Math.max(diff, 0);

        if (diff <= 0) {
            const hoyISO = getFechaSantiago(now);
            const proximo = obtenerProximoDiaHabil(hoyISO);
            element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
            element.dataset.initialized = "true";
            clearInterval(intervalId);
            return;
        }

        const mensaje =
            "¡Llega HOY!<br><span class='santiago'>Aún estás a tiempo:</span><br>" +
            `<span class='remaining-time'>${formatCountdown(diff)}</span>`;
        element.innerHTML = mensaje;
    };

    tick();
    const intervalId = setInterval(tick, 1000);
}

function deliveryMessage2() {
    const elements = document.querySelectorAll(".delivery-message2");

    elements.forEach((element) => {
        if (element.dataset.initialized) return;

        const now = getFechaCompletaSantiago();
        const hoyISO = getFechaSantiago(now);
        const dia = now.getDay();
        const esDomingo = dia === 0;
        const habilitadoHoy = esDomingo && esDomingoHabilitado(hoyISO);
        const cutOffTime = new Date(now);
        cutOffTime.setHours(habilitadoHoy ? 14 : 14, 0, 0, 0);

        if (esFeriado(hoyISO)) {
            const proximo = obtenerProximoDiaHabil(hoyISO);
            element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
        } else if ((dia >= 1 && dia <= 6) || habilitadoHoy) {
            if ((dia === 6 && now > cutOffTime) || (esDomingo && !habilitadoHoy)) {
                const proximo = obtenerProximoDiaHabil(hoyISO);
                element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
            } else if (
                (dia >= 1 && dia <= 5 && now <= cutOffTime) ||
                (dia === 6 && now <= cutOffTime) ||
                habilitadoHoy
            ) {
                updateCountdown(cutOffTime, element);
            } else {
                const proximo = obtenerProximoDiaHabil(hoyISO);
                element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
            }
        } else {
            const proximo = obtenerProximoDiaHabil(hoyISO);
            element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
        }

        element.dataset.initialized = "true";
    });
}

// Lanzamiento inicial
deliveryMessage2();

// Observa cambios en el DOM por navegación AJAX (Shopify)
const observer = new MutationObserver(() => {
    deliveryMessage2();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Reintento automático cada 500ms para detectar catálogos AJAX
function iniciarReintentosDinamicos() {
    const reintento = setInterval(() => {
        const pendientes = document.querySelectorAll('.delivery-message2:not([data-initialized])');
        if (pendientes.length > 0) {
            deliveryMessage2();
        }
    }, 500);

    // Detener reintentos tras 20 segundos
    setTimeout(() => clearInterval(reintento), 20000);
}

document.addEventListener('DOMContentLoaded', iniciarReintentosDinamicos);
document.addEventListener('shopify:section:load', () => {
    deliveryMessage2();
    iniciarReintentosDinamicos();
});
